/**
 * Id-array props whose CONTENT is what matters, not their identity.
 *
 * These carry a handful of territory ids ("what can I attack from here"), and
 * their producers rebuild them from `state` — so every socket message minted a
 * new-but-identical array and the default shallow comparator re-rendered the
 * whole board for it. That is the difference the maintainer feels between the
 * map explorer (no selection arrays, no halos) and a live turn.
 *
 * Comparing them element-wise costs a few pointer checks against a full board
 * render, and it makes MapView robust to a caller that forgets to memoise.
 */
const ID_ARRAY_PROPS = new Set(['validTargetIds', 'adjacentTerritoryIds', 'previewTargetIds'])

function sameIds(a: unknown, b: unknown): boolean {
  if (a === b) return true
  if (!Array.isArray(a) || !Array.isArray(b)) return false
  if (a.length !== b.length) return false
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false
  return true
}

export function mapViewPropsEqual(
  prev: Record<string, unknown>,
  next: Record<string, unknown>,
): boolean {
  const keys = new Set([...Object.keys(prev), ...Object.keys(next)])
  for (const key of keys) {
    if (ID_ARRAY_PROPS.has(key)) {
      if (!sameIds(prev[key], next[key])) return false
      continue
    }
    if (prev[key] !== next[key]) return false
  }
  return true
}

